import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiFetch } from "../utils/api";
import { Ayuda } from "../context/AyudaContext";
import Cargando from "../components/Cargando";

const ESTADOS_ACTIVO = {
  pendiente: { texto: "Pendiente de etiquetar", color: "#a3402f", bg: "#f7ded9" },
  etiquetado: { texto: "Etiquetado, sin entregar", color: "#fff", bg: "var(--tema-titulo, #0b3c60)" },
  entregado: { texto: "Entregado", color: "#2f7a54", bg: "#dcf0e6" },
};

const FILTROS_ESTADO = [
  { valor: "", texto: "Todos los estados" },
  { valor: "pendiente", texto: "Pendiente de etiquetar" },
  { valor: "etiquetado", texto: "Etiquetado, sin entregar" },
  { valor: "entregado", texto: "Entregado" },
];

const formVacio = {
  codigo_activo: "",
  marca: "",
  modelo: "",
  numero_serie: "",
  fecha_adquisicion: "",
  edificio_id: "",
  entregado_a: "",
};

function Badge({ estado }) {
  const info = ESTADOS_ACTIVO[estado] || { texto: estado, color: "#5b6472", bg: "#eef1f3" };
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "0.3rem",
        padding: "0.2rem 0.65rem",
        borderRadius: 999,
        fontSize: "0.76rem",
        fontWeight: 700,
        color: info.color,
        background: info.bg,
        whiteSpace: "nowrap",
      }}
    >
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: info.color, flexShrink: 0 }} />
      {info.texto}
    </span>
  );
}

function Activos() {
  const usuario = JSON.parse(localStorage.getItem("usuario") || "null");
  const esCompras = usuario?.rol === "compras" || usuario?.rol === "administrador";
  const esAdmin = usuario?.rol === "administrador";
  // Editar un activo es exclusivo del administrador.
  const puedeEditar = esAdmin;
  const primerNombre = usuario?.nombre?.split(" ")[0] || "";
  const hora = new Date().getHours();
  const saludoHora = hora < 12 ? "Buenos días" : hora < 19 ? "Buenas tardes" : "Buenas noches";

  const [activos, setActivos] = useState([]);
  const [edificios, setEdificios] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");

  const [busqueda, setBusqueda] = useState("");
  const [estadoFiltro, setEstadoFiltro] = useState("");

  const [editandoId, setEditandoId] = useState(null);
  const [form, setForm] = useState(formVacio);
  const [guardando, setGuardando] = useState(false);

  const cargar = () => {
    setCargando(true);
    apiFetch("/api/activos")
      .then((data) => setActivos(data || []))
      .catch((err) => setError(err.message))
      .finally(() => setCargando(false));
  };

  useEffect(() => {
    cargar();
    apiFetch("/api/edificios")
      .then((data) => setEdificios(data || []))
      .catch(() => {});
  }, []);

  const texto = busqueda.trim().toLowerCase();
  const filtrados = activos.filter((a) => {
    const coincideEstado = !estadoFiltro || a.estado === estadoFiltro;
    const coincideTexto =
      !texto ||
      [a.codigo_activo, a.descripcion_producto, a.marca, a.modelo, a.numero_serie, a.entregado_a, a.solicitante_nombre]
        .filter(Boolean)
        .some((campo) => campo.toLowerCase().includes(texto));
    return coincideEstado && coincideTexto;
  });

  const abrirEdicion = (a) => {
    setEditandoId(a.id);
    setForm({
      codigo_activo: a.codigo_activo || "",
      marca: a.marca || "",
      modelo: a.modelo || "",
      numero_serie: a.numero_serie || "",
      fecha_adquisicion: a.fecha_adquisicion ? a.fecha_adquisicion.slice(0, 10) : "",
      edificio_id: a.edificio_id || "",
      entregado_a: a.entregado_a || "",
    });
    setError("");
  };

  const cerrarEdicion = () => {
    setEditandoId(null);
    setForm(formVacio);
  };

  const guardarEdicion = async () => {
    setGuardando(true);
    setError("");
    try {
      await apiFetch(`/api/activos/${editandoId}/editar`, {
        method: "POST",
        body: JSON.stringify(form),
      });
      cerrarEdicion();
      cargar();
    } catch (err) {
      setError(err.message);
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div>
      <h2 style={{ margin: 0, color: "var(--tema-titulo, #0b3c60)", textAlign: "center" }}>🏷️ Activos Fijos</h2>
      <Ayuda>
        <p style={{ color: "#5b6472", marginTop: "0.25rem", textAlign: "center" }}>
          Inventario de todos los bienes etiquetados como activo fijo, sin importar de qué solicitud
          vinieron — dónde están y a nombre de quién quedaron.
        </p>
      </Ayuda>

      <div className="barra-filtros" style={styles.filtros}>
        <input
          type="text"
          placeholder="🔎 Buscar por Cod. Inventario, producto, responsable..."
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          style={{ ...styles.input, minWidth: 260, flex: 1 }}
        />
      </div>

      <div style={styles.pills}>
        {FILTROS_ESTADO.map((f) => {
          const info = f.valor ? ESTADOS_ACTIVO[f.valor] : null;
          const activo = estadoFiltro === f.valor;
          const estiloColor = info
            ? activo
              ? { background: info.color, borderColor: info.color, color: "#fff" }
              : { background: info.bg, borderColor: info.bg, color: info.color }
            : activo
            ? styles.pillActivo
            : {};
          return (
            <button
              key={f.valor}
              type="button"
              onClick={() => setEstadoFiltro(f.valor)}
              style={{ ...styles.pill, ...estiloColor }}
            >
              {f.texto}
            </button>
          );
        })}
      </div>

      {error && <p style={{ color: "#a3402f" }}>{error}</p>}

      {cargando ? (
        <Cargando compacto />
      ) : filtrados.length === 0 ? (
        <div className="vacio-card" style={styles.vacioCard}>
          <div style={styles.vacioIconoWrap}>
            <div
              style={{
                ...styles.vacioGlow,
                background: busqueda || estadoFiltro ? "rgba(47,102,144,0.16)" : "rgba(47,122,84,0.16)",
              }}
            />
            <span
              className="vacio-anillo"
              style={{ ...styles.vacioAnillo, borderColor: busqueda || estadoFiltro ? "var(--tema-primario, #2f6690)" : "#2f7a54" }}
            />
            <div
              style={{
                ...styles.vacioIcono,
                background: busqueda || estadoFiltro ? "var(--tema-suave, #dceaf5)" : "#dcf0e6",
                color: busqueda || estadoFiltro ? "var(--tema-primario, #2f6690)" : "#2f7a54",
              }}
            >
              {busqueda || estadoFiltro ? "🔍" : "🏷️"}
            </div>
          </div>
          <p style={styles.vacioEyebrow}>
            {saludoHora}
            {primerNombre ? `, ${primerNombre}` : ""} 👋
          </p>
          <h3 style={styles.vacioTitulo}>
            {busqueda || estadoFiltro ? "Sin resultados en este filtro" : "Todavía no hay activos registrados"}
          </h3>
          <p style={styles.vacioTexto}>
            {busqueda || estadoFiltro
              ? "Ningún activo coincide con esa búsqueda o estado."
              : "Cuando compras etiquete un producto marcado como activo fijo, va a aparecer aquí."}
          </p>
          {(busqueda || estadoFiltro) && (
            <div style={{ display: "flex", gap: "0.6rem", justifyContent: "center", marginTop: "1.25rem" }}>
              <button
                type="button"
                className="vacio-refrescar"
                onClick={() => {
                  setBusqueda("");
                  setEstadoFiltro("");
                }}
                style={styles.vacioBoton}
              >
                🧹 Limpiar filtros
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className="table-scroll" style={styles.tablaWrap}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.88rem" }}>
            <thead>
              <tr style={{ textAlign: "center", borderBottom: "1px solid #d3d9df" }}>
                <th style={styles.th}># Solicitud</th>
                <th style={styles.th}>Cod. Inventario</th>
                <th style={styles.th}>Producto</th>
                <th style={styles.th}>Marca</th>
                <th style={styles.th}>Modelo</th>
                <th style={styles.th}>Serie</th>
                <th style={styles.th}>Edificio</th>
                <th style={styles.th}>Recibido por</th>
                <th style={styles.th}>Fecha</th>
                <th style={styles.th}>Estado</th>
                {esCompras && <th style={styles.th}>Editar</th>}
              </tr>
            </thead>
            <tbody>
              {filtrados.map((a, i) => (
                <tr key={a.id} style={{ borderBottom: "1px solid #eef1f3", background: i % 2 === 1 ? "#fafbfc" : "transparent" }}>
                  <td style={styles.td}>
                    <Link to={`/solicitud/${a.solicitud_id}`} style={styles.linkFolio}>
                      #{String(a.solicitud_id).padStart(3, "0")}
                    </Link>
                    <div style={{ fontSize: "0.75rem", color: "#8993a1" }}>{a.solicitante_nombre}</div>
                  </td>
                  <td style={{ ...styles.td, fontWeight: 700, color: "var(--tema-titulo, #0b3c60)" }}>{a.codigo_activo || "—"}</td>
                  <td style={styles.td}>{a.descripcion_producto}</td>
                  <td style={styles.td}>{a.marca || "—"}</td>
                  <td style={styles.td}>{a.modelo || "—"}</td>
                  <td style={styles.td}>{a.numero_serie || "—"}</td>
                  <td style={styles.td}>{a.edificio_nombre || "—"}</td>
                  <td style={styles.td}>{a.entregado_a || "—"}</td>
                  <td style={styles.td}>
                    {a.entregado_en ? new Date(a.entregado_en).toLocaleDateString("es-NI") : "—"}
                  </td>
                  <td style={styles.td}>
                    <Badge estado={a.estado} />
                  </td>
                  {esCompras && (
                    <td style={styles.td}>
                      {puedeEditar ? (
                        <button type="button" onClick={() => abrirEdicion(a)} style={styles.botonEditar}>
                          ✏️ Editar
                        </button>
                      ) : (
                        <button
                          type="button"
                          disabled
                          style={{ ...styles.botonEditar, opacity: 0.45, cursor: "not-allowed" }}
                          title="Solo el administrador puede editar un activo."
                        >
                          ✏️ Editar
                        </button>
                      )}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {editandoId && (
        <div style={styles.modalFondo} onClick={cerrarEdicion}>
          <div style={styles.modalCaja} onClick={(e) => e.stopPropagation()}>
            <div className="modal-franja">
              <h3 style={{ margin: 0, color: "inherit" }}>✏️ Editar activo</h3>
              {form.codigo_activo && <div style={{ fontSize: "0.82rem", opacity: 0.85 }}>{form.codigo_activo}</div>}
            </div>
            <Ayuda>
            <p style={{ fontSize: "0.82rem", color: "#5b6472", marginTop: "-0.5rem" }}>
              Corrige un dato, muévelo de edificio, o reasígnalo a otra persona responsable.
            </p>
            </Ayuda>

            <section className="form-seccion">
            <div className="form-seccion-titulo">🏷️ Identificación</div>
            <div style={styles.campo}>
              <label style={styles.label}>Cod. Inventario</label>
              <input
                type="text"
                value={form.codigo_activo}
                onChange={(e) => setForm({ ...form, codigo_activo: e.target.value })}
                style={styles.input}
              />
            </div>
            <div style={{ display: "flex", gap: "0.6rem" }}>
              <div style={{ ...styles.campo, flex: 1 }}>
                <label style={styles.label}>Marca</label>
                <input
                  type="text"
                  value={form.marca}
                  onChange={(e) => setForm({ ...form, marca: e.target.value })}
                  style={styles.input}
                />
              </div>
              <div style={{ ...styles.campo, flex: 1 }}>
                <label style={styles.label}>Modelo</label>
                <input
                  type="text"
                  value={form.modelo}
                  onChange={(e) => setForm({ ...form, modelo: e.target.value })}
                  style={styles.input}
                />
              </div>
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Número de serie</label>
              <input
                type="text"
                value={form.numero_serie}
                onChange={(e) => setForm({ ...form, numero_serie: e.target.value })}
                style={styles.input}
              />
            </div>
            </section>

            <section className="form-seccion">
            <div className="form-seccion-titulo">📍 Ubicación y responsable</div>
            <div style={{ display: "flex", gap: "0.6rem" }}>
              <div style={{ ...styles.campo, flex: 1 }}>
                <label style={styles.label}>Fecha de adquisición</label>
                <input
                  type="date"
                  value={form.fecha_adquisicion}
                  onChange={(e) => setForm({ ...form, fecha_adquisicion: e.target.value })}
                  style={styles.input}
                />
              </div>
              <div style={{ ...styles.campo, flex: 1 }}>
                <label style={styles.label}>Edificio</label>
                <select
                  value={form.edificio_id}
                  onChange={(e) => setForm({ ...form, edificio_id: e.target.value })}
                  style={styles.input}
                >
                  <option value="">Sin asignar</option>
                  {edificios.map((ed) => (
                    <option key={ed.id} value={ed.id}>
                      {ed.nombre}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Responsable / a quién se le entregó</label>
              <input
                type="text"
                placeholder="Nombre de la persona a cargo"
                value={form.entregado_a}
                onChange={(e) => setForm({ ...form, entregado_a: e.target.value })}
                style={styles.input}
              />
            </div>
            </section>

            {error && <p style={{ color: "#a3402f", fontSize: "0.85rem" }}>{error}</p>}

            <div style={{ display: "flex", gap: "0.6rem", marginTop: "1rem" }}>
              <button type="button" disabled={guardando} onClick={guardarEdicion} style={styles.botonGuardar}>
                {guardando ? "Guardando..." : "💾 Guardar cambios"}
              </button>
              <button type="button" onClick={cerrarEdicion} style={styles.botonCancelar}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  filtros: {
    display: "flex",
    flexWrap: "wrap",
    gap: "0.5rem",
    margin: "1rem 0",
  },
  pills: {
    display: "flex",
    flexWrap: "wrap",
    gap: "0.5rem",
    marginBottom: "1rem",
  },
  pill: {
    border: "1px solid #d3d9df",
    background: "#fff",
    color: "#5b6472",
    borderRadius: 999,
    padding: "0.4rem 0.9rem",
    fontSize: "0.82rem",
    fontWeight: 600,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  pillActivo: {
    background: "var(--tema-titulo, #0b3c60)",
    borderColor: "var(--tema-titulo, #0b3c60)",
    color: "#fff",
  },
  vacioCard: {
    marginTop: "0.5rem",
    border: "1px solid #e2e6ea",
    borderRadius: 14,
    padding: "3rem 1.5rem 2.5rem",
    background: "linear-gradient(180deg, #f7f9fc 0%, #fff 55%)",
    boxShadow: "0 1px 3px rgba(27,42,74,0.06)",
    textAlign: "center",
  },
  vacioIconoWrap: {
    position: "relative",
    width: 96,
    height: 96,
    margin: "0 auto 0.9rem",
  },
  vacioGlow: {
    position: "absolute",
    inset: -10,
    borderRadius: "50%",
  },
  vacioAnillo: {
    position: "absolute",
    inset: 16,
    borderRadius: "50%",
    border: "2px solid",
  },
  vacioIcono: {
    position: "absolute",
    inset: 16,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.8rem",
  },
  vacioEyebrow: {
    margin: "0 0 0.25rem",
    color: "#2f7a54",
    fontSize: "0.82rem",
    fontWeight: 700,
  },
  vacioTitulo: {
    margin: "0 0 0.4rem",
    color: "var(--tema-titulo, #0b3c60)",
    fontSize: "1.25rem",
  },
  vacioTexto: {
    margin: "0 auto",
    maxWidth: 380,
    color: "#5b6472",
    fontSize: "0.88rem",
    lineHeight: 1.5,
  },
  vacioBoton: {
    background: "#fff",
    border: "1px solid #d3d9df",
    borderRadius: 8,
    padding: "0.5rem 1.1rem",
    fontSize: "0.82rem",
    fontWeight: 600,
    color: "var(--tema-titulo, #0b3c60)",
    cursor: "pointer",
  },
  input: {
    padding: "0.45rem 0.6rem",
    border: "1px solid #d3d9df",
    borderRadius: 8,
    fontFamily: "inherit",
    fontSize: "0.85rem",
    width: "100%",
  },
  tablaWrap: {
    background: "#fff",
    border: "1px solid #e2e6ea",
    borderRadius: 12,
    boxShadow: "0 1px 3px rgba(27,42,74,0.06)",
    overflow: "hidden",
  },
  th: {
    padding: "0.6rem 0.5rem",
    background: "#eef1f3",
    border: "1px solid #d3d9df",
    fontSize: "0.78rem",
    color: "var(--tema-titulo, #0b3c60)",
  },
  td: { padding: "0.55rem 0.5rem", textAlign: "center" },
  linkFolio: { color: "var(--tema-primario, #2f6690)", fontWeight: 600, textDecoration: "none" },
  botonEditar: {
    border: "1px solid #d3d9df",
    background: "#fff",
    borderRadius: 8,
    padding: "0.3rem 0.7rem",
    fontSize: "0.78rem",
    fontWeight: 600,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  modalFondo: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: "1rem",
  },
  modalCaja: {
    background: "#f7f9fb",
    padding: "1.5rem",
    borderRadius: 16,
    width: "100%",
    maxWidth: 500,
    maxHeight: "90vh",
    overflowY: "auto",
  },
  campo: { marginTop: "0.75rem", display: "flex", flexDirection: "column", gap: "0.3rem" },
  label: { fontSize: "0.78rem", fontWeight: 600, color: "#5b6472" },
  botonGuardar: {
    background: "var(--tema-titulo, #0b3c60)",
    color: "#fff",
    border: "none",
    borderRadius: 10,
    padding: "0.55rem 1.2rem",
    fontSize: "0.85rem",
    fontWeight: 700,
    cursor: "pointer",
  },
  botonCancelar: {
    background: "#eef1f3",
    color: "#5b6472",
    border: "none",
    borderRadius: 10,
    padding: "0.55rem 1.2rem",
    fontSize: "0.85rem",
    fontWeight: 600,
    cursor: "pointer",
  },
};

export default Activos;
